import { VRMLoaderPlugin } from '@pixiv/three-vrm'
import { VRMAnimationLoaderPlugin } from '@pixiv/three-vrm-animation'
import { useRef } from 'react'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

const createVrmLoader = (): GLTFLoader => {
  const loader = new GLTFLoader()
  loader.setCrossOrigin('anonymous')
  loader.register((parser) => new VRMLoaderPlugin(parser))
  loader.register((parser) => new VRMAnimationLoaderPlugin(parser))

  return loader
}

/**
 * VRM と VRMA の両方を読み込める GLTFLoader を作成する。
 *
 * 同じ viewer 内で VRM 本体と VRMA モーションを読むため、loader の crossOrigin 設定と
 * plugin 登録をここに集約する。呼び出し側は用途ごとに loader を作り分けず、この関数の
 * 戻り値を VRM 読み込みと VRMA 読み込みで共有する。
 */
export const useVrmLoader = (): GLTFLoader => {
  const loaderRef = useRef<GLTFLoader | null>(null)

  if (!loaderRef.current) loaderRef.current = createVrmLoader()

  return loaderRef.current
}
